import React, { Fragment } from 'react'
import Button from '@material-ui/core/Button'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableRow from '@material-ui/core/TableRow'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  tableCell: {
    borderBottom: 'none'
  },
  tableCellBold: {
    fontWeight: 500,
    borderBottom: 'none'
  },
  button: {
    minWidth: 100
  }
}))

const SubscriptionPlanCurrent = ({
  planName,
  endDate,
  cancel = () => {},
  isOffline
}) => {
  const classes = useStyles()

  return (
    <Fragment>
      <TableContainer>
        <Table aria-label='Subscription Plans' size='small'>
          <TableBody>
            <TableRow>
              <TableCell
                className={classes.tableCellBold}
                component='th'
                scope='row'
                align='right'
              >
                Plan Name:
              </TableCell>
              <TableCell className={classes.tableCell} align='center'>
                {planName}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                className={classes.tableCellBold}
                component='th'
                scope='row'
                align='right'
              >
                End Date:
              </TableCell>
              <TableCell className={classes.tableCell} align='center'>
                {endDate}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                className={classes.tableCell}
                component='th'
                scope='row'
                align='right'
              ></TableCell>
              <TableCell className={classes.tableCell} align='center'>
                <Button
                  className={classes.button}
                  variant='contained'
                  color='secondary'
                  onClick={() => cancel}
                  disabled={isOffline}
                  size='small'
                >
                  Cancel Subscription
                </Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Fragment>
  )
}

export default SubscriptionPlanCurrent
